import ProjectAsset from '~/models/ProjectData/ProjectAsset'

/**
 * @memberOf ProjectData
 * @extends ProjectData.ProjectAsset
 *
 */

class ProjectImageAsset extends ProjectAsset {

  // eslint-disable-next-line no-unused-vars
  constructor(jsonData, version) {
    super(jsonData)

    const { settings, mediaFileDuration, originDuration, colorPrimaries } = jsonData

    this._originDuration = originDuration || mediaFileDuration
    this._mediaFileDuration = mediaFileDuration
    this._settings = { ...settings }
    this._colorPrimaries = colorPrimaries
  }

  get colorPrimaries() {
    return this._colorPrimaries
  }

  /**
   * @param {string} colorPrimaries
   */
  set colorPrimaries(value) {
    this._colorPrimaries = value
  }

  get mediaFileDuration() {
    return this._mediaFileDuration
  }

  /**
   * @param {number} mediaFileDuration
   */
  set mediaFileDuration(mediaFileDuration) {
    this._mediaFileDuration = mediaFileDuration
  }

  /**
   * @returns {Object}
   */
  get settings() {
    return this._settings
  }

  /**
   * @returns {number}
   */
  get width() {
    return this._width
  }

  /**
   * @param {number} width
   */
  set width(width) {
    this._width = width
  }

  /**
   * @returns {number}
   */
  get height() {
    return this._height
  }

  /**
   * @param {number} height
   */
  set height(height) {
    this._height = height
  }

}

export default ProjectImageAsset
